<template>
  <div class="product-taiku">
    <!-- Banner图片 -->
    <div class="product-banner">
      <img class="product-banner-img" src="@/assets/img/产品中心.png" alt="产品中心主图" loading="eager" />
    </div>

    <!-- 产品分类标签 -->
    <div class="tk-section tk-category">
      <div class="tk-intro-title">产品中心</div>
      <div class="tk-intro-sub">Product Center</div>
      <div class="category-tabs">
        <el-tabs v-model="activeCategory" @tab-click="handleCategoryClick" class="product-tabs">
          <el-tab-pane label="全部" name="all"></el-tab-pane>
<!--          <el-tab-pane label="现货" name="spot"></el-tab-pane>-->
          <el-tab-pane label="多肽" name="catalog"></el-tab-pane>
          <el-tab-pane label="探针前体" name="pet"></el-tab-pane>
          <el-tab-pane label="靶向肽" name="targeting"></el-tab-pane>
<!--          <el-tab-pane label="肽库" name="library"></el-tab-pane>-->
          <el-tab-pane label="肽片段" name="fragment"></el-tab-pane>
          <el-tab-pane label="ADC Linker" name="adc"></el-tab-pane>

          <el-tab-pane label="抑制剂" name="inhibitor"></el-tab-pane>
          <el-tab-pane label="药效肽" name="efficacy"></el-tab-pane>
          <el-tab-pane label="肽类似物" name="analog"></el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 搜索框 -->
    <div class="tk-section tk-search-section">
      <div class="search-wrapper">
        <el-input
          v-model="searchKeyword"
          placeholder="请输入产品名称或CAS号搜索"
          class="product-search-input"
          clearable
          @clear="handleSearch"
          @keyup.enter.native="handleSearch"
        ></el-input>
        <el-button type="primary" class="search-btn" @click="handleSearch">
          <i class="el-icon-search"></i>
          搜索
        </el-button>
      </div>
    </div>

    <!-- 产品列表 -->
    <div class="tk-section tk-product-list">
      <div class="product-header">
        <div class="product-count">共找到 {{ filteredProducts.length }} 个产品</div>
        <div class="product-sort">
          <el-select v-model="sortBy" placeholder="排序方式" size="small" @change="handleSort">
            <el-option label="默认排序" value="default"></el-option>
            <el-option label="按名称排序" value="name"></el-option>
            <el-option label="按CAS号排序" value="cas"></el-option>
          </el-select>
        </div>
      </div>

      <div class="product-grid">
        <div
          class="product-item"
          v-for="(product, index) in paginatedProducts"
          :key="index"
          @click="handleProductClick(product)"
        >
          <div class="product-name">{{ product.name }}</div>
          <div class="product-cas" v-if="product.cas">CAS: {{ product.cas }}</div>
          <div class="product-desc" v-if="product.description">{{ product.description }}</div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="product-pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 40, 60, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="filteredProducts.length"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 产品详情弹框 -->
    <el-dialog
      :title="selectedProduct.name"
      :visible.sync="dialogVisible"
      width="500px"
      center
      :append-to-body="true"
    >
      <div class="product-detail-content">
        <div class="detail-image" v-if="selectedProduct.image">
          <img :src="selectedProduct.image" class="detail-img" loading="lazy" />
        </div>
        <div class="detail-item" v-if="selectedProduct.cas">
          <span class="detail-label">CAS号:</span>
          <span class="detail-value">{{ selectedProduct.cas }}</span>
        </div>
        <div class="detail-item" v-if="selectedProduct.category">
          <span class="detail-label">分类:</span>
          <span class="detail-value">{{ getCategoryName(selectedProduct.category) }}</span>
        </div>
        <div class="detail-item" v-if="selectedProduct.description">
          <span class="detail-label">描述:</span>
          <span class="detail-value">{{ selectedProduct.description }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 底部信息 -->
    <div class="tk-footer">
      <div>电话：15002819872&nbsp; 邮箱：15002819872@163.com&nbsp; 地址：江西省赣州市章贡区长征大道12号</div>
      <div>备案号: <a href="https://beian.miit.gov.cn/#/Integrated/index">赣ICP备2026004521号-1</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Product',
  data() {
    return {
      activeCategory: 'all',
      searchKeyword: '',
      sortBy: 'default',
      currentPage: 1,
      pageSize: 20,
      dialogVisible: false,
      selectedProduct: {},
      // 示例产品数据（实际应该从API获取）
      allProducts: [
        { name: 'CH-288', cas: '174688-77-8', category: 'catalog',description: '', image: require('@/assets/img/product/CH-288.jpg')  },
        { name: 'cyclolinopeptide Q', cas: '1621670-73-2', category: 'catalog',description: '', image: require('@/assets/img/product/cyclolinopeptide Q.png')  },
        { name: 'WKYMVm', cas: '187986-17-0', category: 'catalog',description: '', image: require('@/assets/img/product/WKYMVm.png') },
        { name: 'LyP-1', cas: '454487-07-1', category: 'catalog',description: '', image: require('@/assets/img/product/LyP-1.png') },
        { name: 'DPDPE', cas: '88373-73-3', category: 'catalog',description: '', image: require('@/assets/img/product/DPDPE.png') },
        { name: 'Temporin A', cas: '188713-69-1', category: 'catalog',description: 'H-Phe-Leu-Pro-Leu-Ile-Gly-Arg-Val-Leu-Ser-Gly-Ile-Leu-NH2', image: ''},
        { name: 'SN50', cas: '213546-53-3', category: 'catalog',description: 'H-Ala-Ala-Val-Ala-Leu-Leu-Pro-Ala-Val-Leu-Leu-Ala-Leu-Leu-Ala-Pro-Val-Gln-Arg-Lys-Arg-Gln-Lys-Leu-Met-Pro-OH', image: '' },
        { name: 'SN52', cas: '1071173-56-2', category: 'catalog',description: 'H-Ala-Ala-Val-Ala-Leu-Leu-Pro-Ala-Val-Leu-Leu-Ala-Leu-Leu-Ala-Pro-Val-Gln-Arg-Lys-Arg-Arg-Lys-Ala-Leu-Pro-OH', image: ''},
        { name: 'P15', cas: '134335-45-8', category: 'catalog',description: 'H-Gly-Thr-Pro-Gly-Pro-Gln-Gly-Ile-Ala-Gly-Gln-Arg-Gly-Val-Val-OH', image: ''},
        { name: 'iRGD peptide', cas: '1392278-76-0', category: 'catalog',description: '', image: require('@/assets/img/product/iRGD peptide.png') },
        { name: 'Reltecimod', cas: '1447799-33-8', category: 'catalog',description: 'H-Ala-Ser-Pro-Met-Leu-Val-Ala-Tyr-Asp-Ala-OH', image: '' },
        { name: 'DK221', cas: '1886065-39-9', category: 'catalog',description: '', image: require('@/assets/img/product/DK221.png') },
        { name: 'AZD-5582', cas: '1258392-53-8', category: 'catalog',description: '', image: require('@/assets/img/product/AZD-5582.png') },
        { name: 'GGGCNGRC(disulfide bond )', cas: '1415747-59-9', category: 'catalog',description: '', image: require('@/assets/img/product/GGGCNGRC(disulfide bond ).png') },
        { name: 'c[RGDfK(N3)]', cas: '868845-09-4', category: 'catalog',description: '', image: require('@/assets/img/product/c[RGDfK(N3)].png') },
        { name: 'SM253', cas: '1610546-52-5', category: 'catalog',description: '', image: require('@/assets/img/product/SM253.png') },
        { name: 'VKRKKKP-R8', cas: '1379519-72-8', category: 'catalog',description: 'H-Val-Lys-Arg-Lys-Lys-Lys-Pro-Arg-Arg-Arg-Arg-Arg-Arg-Arg-Arg-OH', image: ''},
        { name: 'N-stearyl-PKKKRKVRRRRRRRR', cas: '1379519-69-3', category: 'catalog',description: 'C18-Pro-Lys-Lys-Lys-Arg-Lys-Val-Arg-Arg-Arg-Arg-Arg-Arg-Arg-Arg-OH', image: ''},
        { name: 'c[Arg(Pbf)-Gly-Asp(OtBu)-DPhe-Lys]', cas: '226559-04-2', category: 'catalog',description: '', image: require('@/assets/img/product/c[Arg(Pbf)-Gly-Asp(OtBu)-DPhe-Lys].png') },
        { name: 'α-conotoxin AuIB globular', cas: '216299-21-7', category: 'catalog',description: 'Gly-Cys-Cys-Ser-Tyr-Pro-Pro-Cys-Phe-Ala-Thr-Asn-Pro-Asp-Cys-NH2(Cys2&Cys8,Cys3&Cys15 bridge)', image: '' },
        { name: 'Calcitonin Gene Related Peptide(CGRP)', cas: '99889-63-1', category: 'catalog',description: 'H-Ser-Cys-Asn-Thr-Ala-Thr-Cys-Val-Thr-His-Arg-Leu-Ala-Gly-Leu-Leu-Ser-Arg-Ser-Gly-Gly-Val-Val-Lys-Asp-Asn-Phe-Val-Pro-Thr-Asn-Val-Gly-Ser-Lys-Ala-Phe-NH2 \n' +
              '( Cys2&Cys7  Bridge', image: '' },
        { name: 'Cyclo-(Arg-Ala-Asp-DPhe-Val)', cas: '137813-36-6', category: 'catalog',description: '', image: require('@/assets/img/product/137813-36-6.png') },
        { name: 'FAP targeting peptide for FXX489', cas: '3076328-74-7', category: 'catalog',description: '', image: require('@/assets/img/product/3076328-74-7.png') },
        { name: 'FAP targeting peptide-PEG2 conjugate', cas: '3076328-71-4', category: 'catalog',description: '', image: require('@/assets/img/product/3076328-71-4.png') },
        { name: 'DAG peptide', cas: 'N/A', category: 'catalog',description: '', image: require('@/assets/img/product/DAG peptide.png') },
        { name: 'pH-Low Insertion Peptide', cas: '2293160-09-3', category: 'catalog',description: '', image: require('@/assets/img/product/2293160-09-3.png') },
        { name: 'Muscle homing peptide M12', cas: '2896181-32-9', category: 'catalog',description: '', image: require('@/assets/img/product/2896181-32-9.png') },
        { name: 'Kidney-targeting peptide', cas: 'N/A', category: 'catalog',description: '', image: require('@/assets/img/product/Kidney-targeting peptide.png') },
        { name: 'LNSMGQD', cas: '1152066-26-6', category: 'catalog',description: '', image: require('@/assets/img/product/1152066-26-6.png') },
        { name: 'Sulanemadli', cas: '1451199-98-6', category: 'catalog',description: '', image: require('@/assets/img/product/1451199-98-6.png') },
        { name: 'MOG (35-55) mouse, rat', cas: '149635-73-4', category: 'catalog',description: '', image: require('@/assets/img/product/149635-73-4.png') },
        { name: 'Angiotensin II human', cas: '4474-91-3', category: 'catalog',description: '', image: require('@/assets/img/product/4474-91-3.png') },
        { name: 'BTM-001', cas: '2919596-13-5', category: 'catalog',description: '', image: require('@/assets/img/product/2919596-13-5.png') },
        { name: 'TN14003', cas: '368874-31-1', category: 'catalog',description: '', image: require('@/assets/img/product/368874-31-1.png') },
        { name: 'Senktide', cas: '106128-89-6', category: 'catalog',description: '', image: require('@/assets/img/product/106128-89-6.png') },
        { name: 'EB1 peptide', cas: '952754-66-4', category: 'catalog',description: '', image: require('@/assets/img/product/952754-66-4.png') },
        { name: 'Plecanatide', cas: '467426-54-6', category: 'catalog',description: '', image: require('@/assets/img/product/467426-54-6.png') },
        { name: 'FSH1', cas: '142154-55-0', category: 'catalog',description: '', image: require('@/assets/img/product/142154-55-0.png') },
        { name: 'PACAP (1-38), human, ovine, rat', cas: '137061-48-4', category: 'catalog',description: '', image: require('@/assets/img/product/137061-48-4.png') },
        { name: 'Petrelintide', cas: '2766385-23-1', category: 'catalog',description: '', image: require('@/assets/img/product/2766385-23-1.png') },
        { name: 'Rusfertide', cas: '1628323-80-7', category: 'catalog',description: '', image: require('@/assets/img/product/1628323-80-7.png') },
        { name: 'Retatrutide', cas: '2381089-83-2', category: 'catalog',description: '', image: require('@/assets/img/product/2381089-83-2.png') },
        { name: 'DG3173', cas: '252845-37-7', category: 'catalog',description: '', image: require('@/assets/img/product/252845-37-7.png') },
        { name: 'Elamipretide', cas: '736992-21-5', category: 'catalog',description: '', image: require('@/assets/img/product/736992-21-5.png') },
        { name: 'pasireotide', cas: '396091-73-9', category: 'catalog',description: '', image: require('@/assets/img/product/396091-73-9.png') },
        { name: 'Selepressin', cas: '876296-47-8', category: 'catalog',description: '', image: require('@/assets/img/product/876296-47-8.png') },
        { name: '3XFlag Peptide', cas: '402750-12-3', category: 'catalog',description: '', image: require('@/assets/img/product/402750-12-3.png') },
        { name: 'ALX-0600', cas: '197922-42-2', category: 'catalog',description: '', image: require('@/assets/img/product/197922-42-2.png') },
        { name: 'Helospectin I', cas: '93438-37-0', category: 'catalog',description: '', image: require('@/assets/img/product/93438-37-0.png') },
        { name: 'GIP(1-39)', cas: '725474-97-5', category: 'catalog',description: '', image: require('@/assets/img/product/725474-97-5.png') },
        { name: 'Dermcidin-1L (human)', cas: '478898-18-9', category: 'catalog',description: '', image: require('@/assets/img/product/478898-18-9.png') },
        { name: 'PD-L1 inhibitory peptide', cas: '1931111-41-9', category: 'catalog',description: '', image: require('@/assets/img/product/1931111-41-9.png') },
        { name: 'Exendin(9-39) amide', cas: '133514-43-9', category: 'catalog',description: '', image: require('@/assets/img/product/133514-43-9.png') },
        { name: 'c(RGDyC)', cas: '1206475-79-7', category: 'catalog',description: '', image: require('@/assets/img/product/1206475-79-7.png') },
        { name: 'β-Amyloid (1-42), human', cas: '107761-42-2', category: 'catalog',description: '', image: require('@/assets/img/product/107761-42-2.png') },
        { name: 'DK221', cas: '1886065-39-9', category: 'catalog',description: '', image: require('@/assets/img/product/1886065-39-9.png') },
        { name: 'NOTA-PCP2', cas: 'N/A', category: 'catalog',description: '', image: require('@/assets/img/product/NOTA-PCP2.png') },
        { name: 'G-Pen-GRGDSPCA', cas: '126716-28-7', category: 'catalog',description: '', image: require('@/assets/img/product/126716-28-7.png') },
        { name: 'ABT-510', cas: '251579-55-2', category: 'catalog',description: '', image: require('@/assets/img/product/251579-55-2.png') },



        { name: 'FAPI-mFS', cas: '3023869-94-2', category: 'pet',description: '', image: require('@/assets/img/product/3023869-94-2.png')},
        { name: 'DOTA-(FAPI-04)2', cas: '3029114-60-8', category: 'pet',description: '', image: require('@/assets/img/product/3029114-60-8.png')},
        { name: 'LNC1007', cas: '2892402-57-0', category: 'pet',description: '', image: require('@/assets/img/product/2892402-57-0.png')},
        { name: 'FAPI 34', cas: '2374782-07-5', category: 'pet',description: '', image: require('@/assets/img/product/2374782-07-5.png')},
        { name: '(S)-EB-FAPI-B2', cas: '2740747-99-1', category: 'pet',description: '', image: require('@/assets/img/product/2740747-99-1.png')},
        { name: 'FAPI-P8PN', cas: '2921619-09-0', category: 'pet',description: '', image: require('@/assets/img/product/2921619-09-0.png')},
        { name: 'DOTAGA.Glu.(FAPi)2', cas: '2882922-68-9', category: 'pet',description: '', image: require('@/assets/img/product/2882922-68-9.png')},
        { name: 'ADVC001', cas: '3029011-76-2', category: 'pet',description: '', image: require('@/assets/img/product/3029011-76-2.png')},
        { name: 'DOTA-NI-FAPI-04', cas: '3078291-78-5', category: 'pet',description: '', image: require('@/assets/img/product/3078291-78-5.png')},
        { name: 'PSMA-D5', cas: '3056440-83-3', category: 'pet',description: '', image: require('@/assets/img/product/3056440-83-3.png')},
        { name: 'FAPI-800CW', cas: '', category: 'pet',description: '', image: require('@/assets/img/product/FAPI-800CW.png')},
        { name: 'FAPI-JNU', cas: '', category: 'pet',description: '', image: require('@/assets/img/product/FAPI-JNU.png')},
        { name: 'FAPI-FUSCC-07', cas: '3097341-30-2', category: 'pet',description: '', image: require('@/assets/img/product/3097341-30-2.png')},
        { name: 'FAPI-04', cas: '2374782-02-0', category: 'pet',description: '', image: require('@/assets/img/product/2374782-02-0.png')},
        { name: 'NOTA-FAPI-42', cas: '2374782-03-1', category: 'pet',description: '', image: require('@/assets/img/product/2374782-03-1.png')},
        { name: 'FAPI-46', cas: '2374782-04-2', category: 'pet',description: '', image: require('@/assets/img/product/2374782-04-2.png')},
        { name: 'PSMA-617', cas: '1702967-37-0', category: 'pet',description: '', image: require('@/assets/img/product/1702967-37-0.png')},
        { name: 'PSMA-11', cas: '1366302-52-4', category: 'pet',description: '', image: require('@/assets/img/product/1366302-52-4.png')},
        { name: 'PSMA I＆T', cas: '2192281-54-0', category: 'pet',description: '', image: require('@/assets/img/product/2192281-54-0.png')},
        { name: '(R)-PSMA I＆T', cas: '2647371-60-4', category: 'pet',description: '', image: require('@/assets/img/product/2647371-60-4.png')},
        { name: 'PSMA-ALB-56', cas: '2306049-48-7', category: 'pet',description: '', image: require('@/assets/img/product/2306049-48-7.png')},
        { name: 'HYNIC-iPSMA', cas: '2192215-74-8', category: 'pet',description: '', image: require('@/assets/img/product/2192215-74-8.png')},
        { name: 'FAP-IN-8', cas: '3075119-33-1', category: 'pet',description: '', image: require('@/assets/img/product/3075119-33-1.png')},
        { name: 'FAP-IN-4', cas: '3020777-05-0', category: 'pet',description: '', image: require('@/assets/img/product/3020777-05-0.png')},
        { name: 'FAP Ligand 2', cas: 'N/A', category: 'pet',description: '', image: require('@/assets/img/product/FAP Ligand 2 .png')},
        { name: 'FAP-IN-6', cas: 'N/A', category: 'pet',description: '', image: require('@/assets/img/product/FAP-IN-6.png')},
        { name: 'FAP-PI3KI1', cas: '2415941-98-7', category: 'pet',description: '', image: require('@/assets/img/product/2415941-98-7.png')},
        { name: 'FAP Ligand 1', cas: '2230625-76-8', category: 'pet',description: '', image: require('@/assets/img/product/2230625-76-8.png')},
        { name: 'BR102910', cas: '2505339-54-6', category: 'pet',description: '', image: require('@/assets/img/product/2505339-54-6.png')},
        { name: 'PNT6555', cas: '2715113-34-9', category: 'pet',description: '', image: require('@/assets/img/product/2715113-34-9.png')},
        { name: 'OncoFAP-GlyPro-MMAE', cas: '2688118-55-8', category: 'pet',description: '', image: require('@/assets/img/product/2688118-55-8.png')},
        { name: 'ARI-3099', cas: '1432499-49-4', category: 'pet',description: '', image: require('@/assets/img/product/1432499-49-4.png')},
        { name: 'Talabostat', cas: '149682-77-9', category: 'pet',description: '', image: require('@/assets/img/product/149682-77-9.png')},
        { name: 'SB03178', cas: '2952588-12-2', category: 'pet',description: '', image: require('@/assets/img/product/2952588-12-2.png')},
        { name: '3BP-3580', cas: '2374782-82-6', category: 'pet',description: '', image: require('@/assets/img/product/2374782-82-6.png')},
        { name: 'MYZ04', cas: '', category: 'pet',description: '', image: require('@/assets/img/product/MYZ04.png')},
        { name: 'PSMA-ALB-56', cas: '2306049-48-7', category: 'pet',description: '', image: require('@/assets/img/product/2306049-48-71.png')},
        { name: 'SAR-BisPSMA', cas: '2254661-83-9', category: 'pet',description: '', image: require('@/assets/img/product/2254661-83-9.png')},
        { name: 'LNC1007', cas: '2892402-57-0', category: 'pet',description: '', image: require('@/assets/img/product/2892402-57-01.png')},



        { name: 'FITC-Ahx-Gly-Arg-Gly-Asp-Ser-Pro', cas: '2022956-44-9', category: 'targeting',description: '', image: require('@/assets/img/product/2022956-44-9.png')},
        { name: 'Biotin-myelin basic protein (94-102)', cas: '923949-88-6', category: 'targeting',description: '', image: require('@/assets/img/product/923949-88-6.png')},
        { name: 'NOTA-QHY-04', cas: '2658532-09-1', category: 'targeting',description: '', image: require('@/assets/img/product/2658532-09-1.png')},
        { name: 'Ac-Arg-Val-Arg-Arg-Cys(StBu)-Lys-Cbt', cas: '1416901-90-0', category: 'targeting',description: '', image: require('@/assets/img/product/1416901-90-0.png')},
        { name: 'NOTA-c(RGDfK)', cas: '1361403-03-3', category: 'targeting',description: '', image: require('@/assets/img/product/1361403-03-3.png')},
        { name: 'DOTA-NT-20.3', cas: '1262311-97-6', category: 'targeting',description: '', image: require('@/assets/img/product/1262311-97-6.png')},
        { name: 'Hynic-TOC', cas: '257943-19-4', category: 'targeting',description: '', image: require('@/assets/img/product/257943-19-4.png')},
        { name: 'DOTA-cyclo(RGDfK)', cas: '909024-55-1', category: 'targeting',description: '', image: require('@/assets/img/product/909024-55-1.png')},
        { name: 'DOTA-MGS5', cas: '2254491-91-1', category: 'targeting',description: '', image: require('@/assets/img/product/2254491-91-1.png')},
        { name: 'DPI-4452', cas: '2941391-49-5', category: 'targeting',description: '', image: require('@/assets/img/product/2941391-49-5.png')},
        { name: 'Rofapitide tetraxetan', cas: '2581741-18-4', category: 'targeting',description: '', image: require('@/assets/img/product/2581741-18-4.png')},
        { name: 'DOTA-E[c(RGDfK)]2', cas: '250612-06-7', category: 'targeting',description: '', image: require('@/assets/img/product/250612-06-7.png')},
        { name: 'NODAGA-JR11', cas: '1638746-88-9', category: 'targeting',description: '', image: require('@/assets/img/product/1638746-88-9.png')},
        { name: 'Pentixather', cas: '1821136-83-7', category: 'targeting',description: '', image: require('@/assets/img/product/1821136-83-7.png')},
        { name: 'pentixafor', cas: '1341207-62-2', category: 'targeting',description: '', image: require('@/assets/img/product/1341207-62-2.png')},
        { name: 'DOTA-Tyr3-octreotide', cas: '204318-14-9', category: 'targeting',description: '', image: require('@/assets/img/product/204318-14-9.png')},
        { name: 'DOTA-TATE', cas: '177943-89-4', category: 'targeting',description: '', image: require('@/assets/img/product/177943-89-4.png')},
        { name: 'Unlabeled FXX489', cas: '3076330-05-4', category: 'targeting',description: '', image: require('@/assets/img/product/3076330-05-4.png')},
        { name: 'DOTA-LM3', cas: '1192362-32-5', category: 'targeting',description: '', image: require('@/assets/img/product/1192362-32-5.png')},
        { name: 'DOTA-JR11', cas: '1039726-31-2', category: 'targeting',description: '', image: require('@/assets/img/product/1039726-31-2.png')},
        { name: 'NOTA-AE105', cas: '1820563-84-5', category: 'targeting',description: '', image: require('@/assets/img/product/1820563-84-5.png')},
        { name: 'NOTA-P2-RM26', cas: '1446005-10-2', category: 'targeting',description: '', image: require('@/assets/img/product/1446005-10-2.png')},
        { name: 'biotin-Bradykinin', cas: '477319-71-4', category: 'targeting',description: '', image: require('@/assets/img/product/477319-71-4.png')},
        { name: 'HYNIC-UBI29-41', cas: '1186217-15-1', category: 'targeting',description: '', image: require('@/assets/img/product/1186217-15-1.png')},
        { name: 'Biotinyl-LL-37', cas: '2243219-80-7', category: 'targeting',description: '', image: require('@/assets/img/product/2243219-80-7.png')},
        { name: 'Biotinyl-KR-12 (human)', cas: ' 2022956-47-2', category: 'targeting',description: '', image: require('@/assets/img/product/2022956-47-2.png')},
        { name: 'TAM558', cas: '1802499-21-3', category: 'targeting',description: '', image: require('@/assets/img/product/1802499-21-3.png')},
        { name: 'ZL02', cas: '', category: 'targeting',description: '', image: require('@/assets/img/product/ZL02.png')},
        { name: 'DOTAGA-FAP-2286-ALB', cas: '', category: 'targeting',description: '', image: require('@/assets/img/product/DOTAGA-FAP-2286-ALB.png')},
        { name: 'DOTA-BT1718', cas: '', category: 'targeting',description: '', image: require('@/assets/img/product/DOTA-BT1718.png')},
        { name: 'DOTA-BP1', cas: '', category: 'targeting',description: '', image: require('@/assets/img/product/2892402-57-011.png')},
        { name: 'HYNIC-PSMA', cas: '2213408-17-2', category: 'targeting',description: '', image: require('@/assets/img/product/HYNIC-PSMA.png')},
        { name: 'DOTAMTATE', cas: '2415661-92-4', category: 'targeting',description: '', image: require('@/assets/img/product/2415661-92-4.png')},
        { name: 'DOTA-BP1', cas: '', category: 'targeting',description: '', image: require('@/assets/img/product/DOTA-BP1.png')},
        { name: 'DOTA-BT1718', cas: '', category: 'targeting',description: '', image: require('@/assets/img/product/DOTA-BT1718999.png')},
        { name: 'DOTA-GPC3 peptide', cas: '3066439-94-6', category: 'targeting',description: '', image: require('@/assets/img/product/3066439-94-6.png')},
        { name: 'ETN029', cas: '3066864-32-9', category: 'targeting',description: '', image: require('@/assets/img/product/3066864-32-9.png')},
        { name: 'NOTA-COG1410', cas: '2914099-35-5', category: 'targeting',description: '', image: require('@/assets/img/product/2914099-35-5.png')},
        { name: 'NeoBOMB1', cas: '2255342-28-8', category: 'targeting',description: '', image: require('@/assets/img/product/2255342-28-8.png')},
        { name: 'DOTA-Tyr3-octreotide', cas: '204318-14-9', category: 'targeting',description: '', image: require('@/assets/img/product/204318-14-9111.png')}
      ]
    }
  },
  computed: {
    filteredProducts() {
      let products = this.allProducts

      // 按分类筛选
      if (this.activeCategory !== 'all') {
        products = products.filter(p => p.category === this.activeCategory)
      }

      // 按关键词搜索
      if (this.searchKeyword) {
        const keyword = this.searchKeyword.toLowerCase()
        products = products.filter(p => 
          p.name.toLowerCase().includes(keyword) ||
          (p.cas && p.cas.toLowerCase().includes(keyword))
        )
      }

      // 排序
      if (this.sortBy === 'name') {
        products = [...products].sort((a, b) => a.name.localeCompare(b.name))
      } else if (this.sortBy === 'cas') {
        products = [...products].sort((a, b) => {
          const casA = a.cas || ''
          const casB = b.cas || ''
          return casA.localeCompare(casB)
        })
      }

      return products
    },
    paginatedProducts() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filteredProducts.slice(start, end)
    }
  },
  methods: {
    handleCategoryClick(tab) {
      this.currentPage = 1
    },
    handleSearch() {
      this.currentPage = 1
    },
    handleSort() {
      this.currentPage = 1
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
    },
    handleCurrentChange(val) {
      this.currentPage = val
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    handleProductClick(product) {
      this.selectedProduct = product
      this.dialogVisible = true
    },
    getCategoryName(category) {
      const categoryMap = {
        'spot': '现货',
        'catalog': '多肽',
        'pet': 'PET探针前体',
        'library': '肽库',
        'fragment': '肽片段',
        'adc': 'ADC Linker',
        'targeting': '靶向肽',
        'inhibitor': '抑制剂',
        'efficacy': '药效肽',
        'analog': '肽类似物'
      }
      return categoryMap[category] || category
    }
  }
}
</script>
<style scoped>
.product-taiku {
  background: #f5f7fa;
  min-height: 100vh;
}
.product-banner {
  width: 100%;
  overflow: hidden;
  margin-top: 8px;
}
.product-banner-img {
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: cover;
  display: block;
}
.tk-section {
  max-width: 1200px;
  margin: 30px auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  padding: 30px 30px 10px 30px;
}
.tk-intro-title {
  font-size: 28px;
  color: #0e3fa5;
  text-align: center;
  font-weight: bold;
  margin-bottom: 10px;
}
.tk-footer {
  background: #2f2f2f;
  color: #fff;
  text-align: center;
  padding: 30px 0 10px 0;
  margin-top: 40px;
}
.tk-footer div {
  margin: 5px 0;
  font-size: 14px;
}
.tk-footer a {
  color: #fff;
  text-decoration: none;
}
.tk-footer {
  padding: 20px 0 10px 0;
  margin-top: 20px;
  font-size: 12px;
}
.tk-intro-sub {
  font-size: 18px;
  color: #888;
  text-align: center;
  margin-bottom: 20px;
}
.tk-category {
  margin-top: 20px;
}
.category-tabs {
  margin-top: 20px;
}
.product-tabs >>> .el-tabs__header {
  margin: 0;
}
.product-tabs >>> .el-tabs__nav-wrap {
  padding: 0 20px;
}
.product-tabs >>> .el-tabs__item {
  font-size: 15px;
  padding: 0 20px;
}
.tk-search-section {
  margin-top: 20px;
  padding: 20px 30px;
}
.search-wrapper {
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 0;
}
.product-search-input {
  flex: 1;
}
.product-search-input >>> .el-input__inner {
  border-radius: 4px 0 0 4px;
  border-right: none;
}
.product-search-input >>> .el-input__inner:focus {
  border-right: none;
}
.search-btn {
  border-radius: 0 4px 4px 0;
  padding: 0 30px;
  height: 40px;
  background-color: #0e3fa5;
  border-color: #0e3fa5;
  white-space: nowrap;
}
.search-btn:hover {
  background-color: #5a7edc;
  border-color: #5a7edc;
}
.tk-product-list {
  margin-top: 20px;
}
.product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e4e7ed;
}
.product-count {
  font-size: 16px;
  color: #666;
}
.product-sort {
  min-width: 150px;
}
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}
.product-item {
  padding: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  background: #fff;
}
.product-item:hover {
  border-color: #0e3fa5;
  box-shadow: 0 4px 12px rgba(14, 63, 165, 0.15);
  transform: translateY(-2px);
}
.product-name {
  font-size: 16px;
  font-weight: bold;
  color: #0e3fa5;
  margin-bottom: 10px;
  line-height: 1.4;
}
.product-cas {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}
.product-desc {
  font-size: 13px;
  color: #999;
  line-height: 1.5;
}
.product-pagination {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
@media (max-width: 768px) {
  .product-banner-img {
    max-height: 250px;
    object-fit: contain;
  }
  .tk-section {
    margin: 15px 8px;
    padding: 20px 15px;
  }
  .tk-intro-title {
    font-size: 22px;
  }
  .tk-intro-sub {
    font-size: 14px;
    margin-bottom: 15px;
  }
  .category-tabs {
    margin-top: 15px;
  }
  .tk-footer {
    padding: 20px 10px 10px 10px;
    margin-top: 20px;
    font-size: 12px;
    line-height: 1.6;
  }
  .tk-footer div {
    word-break: break-all;
    padding: 0 5px;
  }
  .product-tabs >>> .el-tabs__item {
    font-size: 13px;
    padding: 0 10px;
  }
  .tk-search-section {
    padding: 15px;
  }
  .product-search-input {
    width: 100%;
  }
  .product-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  .product-count {
    font-size: 14px;
  }
  .product-sort {
    width: 100%;
  }
  .product-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  .product-item {
    padding: 15px;
  }
  .product-name {
    font-size: 15px;
  }
  .product-cas {
    font-size: 13px;
  }
  .product-desc {
    font-size: 12px;
  }
  .product-pagination {
    margin-top: 20px;
    padding: 15px 0;
  }
  .product-pagination >>> .el-pagination {
    text-align: center;
  }
  .product-pagination >>> .el-pagination__sizes,
  .product-pagination >>> .el-pagination__jump {
    display: none;
  }
}
.product-detail-content {
  padding: 10px 0;
}
.detail-image {
  margin-bottom: 20px;
  text-align: center;
}
.detail-img {
  max-width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: contain;
  border-radius: 8px;
  display: block;
  margin: 0 auto;
}
.detail-item {
  margin-bottom: 15px;
  line-height: 1.6;
}
.detail-item:last-child {
  margin-bottom: 0;
}
.detail-label {
  font-weight: bold;
  color: #333;
  display: inline-block;
  min-width: 60px;
}
.detail-value {
  color: #666;
}
</style>
<style>
.el-dialog {
  border-radius: 12px !important;
}
/* 手机端弹框适配 */
@media (max-width: 768px) {
  .product-banner-img {
    max-height: 250px;
    object-fit: contain;
  }
  .el-dialog {
    width: 90% !important;
    max-width: 90% !important;
  }
  .el-dialog__body {
    padding: 10px !important;
  }
  .el-dialog__footer {
    padding: 10px 15px !important;
  }
}
/* 防止弹框打开时页面抖动 */
body {
  overflow-y: scroll;
}
</style>


